module.exports = __webpack_public_path__ + "static/media/rename.2d47d25e.svg";